import LazyLoad from "vanilla-lazyload";
import { waitLoad } from "../utilities/load";

const lazyLoadInstance = new LazyLoad({
    use_native: true
});

waitLoad().then(()=>{
    lazyLoadInstance.update();
})